import { render, staticRenderFns } from "./Server.vue?vue&type=template&id=bbe8996c&scoped=true&"
import script from "./Server.vue?vue&type=script&lang=js&"
export * from "./Server.vue?vue&type=script&lang=js&"
import style0 from "./Server.vue?vue&type=style&index=0&id=bbe8996c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe8996c",
  null
  
)

export default component.exports